"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadcrumbsRender = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const BreadcrumbsRender = ({ items }) => {
    const allItems = (0, react_1.useMemo)(() => {
        return [{
                to: "/",
                label: (0, jsx_runtime_1.jsx)("i", { className: "bi bi-house-door-fill" })
            }, ...items];
    }, [items]);
    return ((0, jsx_runtime_1.jsx)("div", { className: "container pt-3", children: (0, jsx_runtime_1.jsx)("nav", { "aria-label": "breadcrumb", children: (0, jsx_runtime_1.jsx)("ol", { className: "breadcrumb", children: allItems.map((item, index) => ((0, jsx_runtime_1.jsx)("li", { className: "breadcrumb-item" + (allItems.length === index + 1 ? " active" : ""), children: allItems.length === index + 1 ? (
                    // <span className="fs-6">{item.label}</span>
                    (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: item.to, className: "text-decoration-none fs-6 link-dark", children: item.label }) })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: item.to, className: "text-decoration-none fs-6", children: item.label }) })) }, index))) }) }) }));
};
exports.BreadcrumbsRender = BreadcrumbsRender;
